import { useSearchParams } from "react-router-dom";
import {
  AB_TEST_10_1_HEADER_PARAM_VALUE,
  AB_TEST_10_2_HEADER_PARAM_VALUE,
  AB_TEST_22_1_PARAM_VALUE,
  AB_TEST_22_2_PARAM_VALUE,
  AB_TEST_4A_1_HEADER_PARAM_VALUE,
  AB_TEST_4A_2_HEADER_PARAM_VALUE,
  AB_TEST_4_1_HEADER_PARAM_VALUE,
  AB_TEST_6_HEADER_PARAM_VALUE,
} from "@/constants";

export const useIsABTest = () => {
  const [searchParams] = useSearchParams();

  const altValue = searchParams.get("alt");
  const isABTest_4_1_Header = [
    AB_TEST_4A_1_HEADER_PARAM_VALUE,
    AB_TEST_4A_2_HEADER_PARAM_VALUE,
    AB_TEST_4_1_HEADER_PARAM_VALUE,
  ].includes(altValue ?? "");

  const isABTest_4A_1_Header = altValue === AB_TEST_4A_1_HEADER_PARAM_VALUE;
  const isABTest_4A_2_Header = altValue === AB_TEST_4A_2_HEADER_PARAM_VALUE;
  const isABTest_6_Header = altValue === AB_TEST_6_HEADER_PARAM_VALUE;
  const isABTest_10_1_USP = altValue === AB_TEST_10_1_HEADER_PARAM_VALUE;
  const isABTest_10_2_USP = altValue === AB_TEST_10_2_HEADER_PARAM_VALUE;
  const isABTest_22_1 = altValue === AB_TEST_22_1_PARAM_VALUE;
  const isABTest_22_2 = altValue === AB_TEST_22_2_PARAM_VALUE;

  return {
    isABTest_4_1_Header,
    isABTest_4A_1_Header,
    isABTest_4A_2_Header,
    isABTest_6_Header,
    isABTest_10_1_USP,
    isABTest_10_2_USP,
    isABTest_22_1,
    isABTest_22_2,
  };
};
